<template>
  <div class="w-full">
    <h2>{{ t('handoverDone') }}</h2>
    <p class="mt-4">
      {{ t('vehicleCanBeHandedOver', { bookingNumber: booking?.bookingNumber }) }}
    </p>
    <BigSuccess />

    <Divider />
    <div class="flex justify-end gap-4">
      <CVButton variant="secondary" :to="{ name: 'bookingEdit', params: { id: route.params.id } }">
        {{ t('showBooking') }}
      </CVButton>
      <CVButton :to="{ name: 'upcomingHandovers' }">
        {{ t('next') }}
      </CVButton>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import BigSuccess from '@/components/BigSuccess.vue';
import Divider from '@/components/Divider.vue';
import { useRoute } from 'vue-router';
import { useBooking } from '@/queries/use-bookings';

const { t } = useI18n();
const route = useRoute();
const { data: booking } = useBooking(route.params.id as string);
</script>

<i18n lang="json">
{
  "en": {
    "handoverDone": "Handover Done",
    "next": "Back to Dashboard",
    "showBooking": "Show Booking",
    "vehicleCanBeHandedOver": "Booking {bookingNumber} can now be handed over."
  },
  "de": {
    "handoverDone": "Übergabe abgeschlossen",
    "next": "Zurück zur Übersicht",
    "showBooking": "Buchung anzeigen",
    "vehicleCanBeHandedOver": "Buchung {bookingNumber} kann jetzt übergeben werden."
  },
  "es": {
    "handoverDone": "Entrega completada",
    "next": "Volver a la vista general",
    "showBooking": "Ver reserva",
    "vehicleCanBeHandedOver": "La reserva {bookingNumber} ya puede entregarse."
  }
}
</i18n>
